module.exports = require("babel-runtime/helpers/extends");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/extends"
// module id = 23
// module chunks = 0